export default "__VITE_ASSET__oDgN5BW6__";